import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, Stepper, Step, StepLabel, Button, RadioGroup, FormControlLabel, Radio, CircularProgress, TextField } from '@material-ui/core';
import { BASE_URL } from '../../../store/config';
import instance from '../../../request/http';
import { roleStr, ADD, EDIT, VIEW } from '../../../common/common';
import Toast from '../../Layout/components/Toast';
import UserAutoComplete from '../../Components/UserAutoComplete';
import PersonList from './PersonList';

const Root = styled(Box)({
    width: '801px',
    padding: '24px',
    '& .page-title': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .title': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#212C31',
        marginTop: '18px',
    },
    '& .text-field': {
        width: '50%',
        paddingRight: '15px',
    },
    '& .text-field-f': {
        width: '100%',
        // paddingRight: '15px',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#F3F3F3',
        margin: '20px 0',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginLeft: '10px',
        },
    },
})

class ReportInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            client: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                wechat: '',
            },
            related_persons: [
                // {
                //     first_name: '',
                //     last_name: '',
                //     email: '',
                //     phone: '',
                //     wechat: '',
                //     relation: '',
                // }
            ],
            showToast: false,
            toastMsg: "",
            toastState: "",
        }
        this.handleCreate = this.handleCreate.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.updateMember = this.updateMember.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    render() {
        const { title, state } = this.props;
        const {
            client,
            related_persons,
            showToast,
            toastMsg,
            toastState,
        } = this.state;
        const btns = () => {
            if (state !== VIEW) {
                return <Button
                    className="btn"
                    variant="contained"
                    color="primary"
                    onClick={this.handleCreate}
                >
                    {state === ADD ? 'create' : 'save'}
                </Button>
            }
        }
        const personView = () => {
            if (state !== VIEW) {
                return <div>
                    <div className="title">Related Persons</div>
                    <PersonList
                        data={related_persons}
                        ref={(child) => { this.personList = child }}
                    ></PersonList>
                </div>
            }
        }
        return (
            <Root>
                <div className="page-title">{title}</div>
                <div className="line"></div>
                <div className="title">Client Info</div>
                <div>
                    <TextField
                        disabled={this.isDisabled()}
                        className="text-field"
                        label='First Name'
                        value={client.first_name}
                        name='first_name'
                        margin="dense"
                        variant="outlined"
                        onChange={this.handleChange}
                    />
                    <TextField
                        disabled={this.isDisabled()}
                        className="text-field"
                        label='Last Name'
                        value={client.last_name}
                        name='last_name'
                        margin="dense"
                        variant="outlined"
                        onChange={this.handleChange}
                    />
                    <TextField
                        disabled={this.isDisabled()}
                        className="text-field"
                        label='Email'
                        value={client.email}
                        name='email'
                        margin="dense"
                        variant="outlined"
                        onChange={this.handleChange}
                    />
                    <TextField
                        disabled={this.isDisabled()}
                        className="text-field"
                        label='Phone'
                        name='phone'
                        value={client.phone}
                        margin="dense"
                        variant="outlined"
                        onChange={this.handleChange}
                    />
                    <TextField
                        disabled={this.isDisabled()}
                        className="text-field"
                        label='Wechat'
                        value={client.wechat}
                        name='wechat'
                        margin="dense"
                        variant="outlined"
                        onChange={this.handleChange}
                    />
                </div>
                {personView()}
                <div className="line"></div>
                <div className="foot h h-r">
                    <Button variant="contained" onClick={this.handleClose}>CANCEL</Button>
                    {btns()}
                </div>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    initData() {
        const { state, data } = this.props;
        if (state !== ADD) {
            if (data) {
                const tempClient = data.client;
                const client = {
                    first_name: tempClient.first_name ? tempClient.first_name : '',
                    last_name: tempClient.last_name ? tempClient.last_name : '',
                    email: tempClient.email ? tempClient.email : '',
                    phone: tempClient.phone ? tempClient.phone : '',
                    wechat: tempClient.wechat ? tempClient.wechat : '',
                }
                this.setState({
                    client,
                    related_persons: [],
                })
            }
        }
    }
    updateMember(member) {
        if (!member) return;
        const user_ids = [];
        user_ids.push(member.id);
        this.setState({
            user_ids
        })
    }
    handleChange(e) {
        const { value, name } = e.target;
        this.setState((prevState) => ({
            client: {
                ...prevState.client,
                [name]: value
            }
        }));
    }
    handleCreate() {
        const { client } = this.state;
        const related_persons = this.personList.getData();
        this.props.handleCreate(client, related_persons);
    }
    handleClose() {
        this.props.handleCancel();
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    //------------request-----------------
}

export default ReportInfo;